.divider {
	border-left: 1px solid var(--ds-border, #dfe1e6);
}
